import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class SantoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(public http: HttpClient) {}

  buscaSantoDia(data) {
    return this.http.post<any>(this.baseUrl + '/santo/get-santo-dia', { data: data }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/santo/santo.ts